import { format } from 'date-fns';
import { isScheduledBooking } from '../services/callback-whitelist';
import { CategoryType, ClaimType, InsuranceType, NavigationState } from '../store/navigation.type';
import { callStartTime, DANISH_DATE_TIME_FORMAT } from '../utils/date-utils';

const TRANSLATIONS: { [key in CategoryType | InsuranceType | ClaimType | '']: string } = {
  insurance: 'Forsikringer',
  injury: 'Skader',
  others: 'Andet',
  offer: 'Tilbud på forsikring',
  change: 'Ændring af forsikring',
  review: 'Gennemgang af forsikring',
  billingOrPayment: 'Regning/betaling',
  CLAIMS_CONTENT: 'Ting/elektronik',
  CLAIMS_AUTO: 'Bil/motorcykel',
  CLAIMS_BUILDING: 'Hus',
  CLAIMS_PERSONAL: 'Krop (ulykke)',
  CLAIMS_ANIMAL: 'Dyr',
  CLAIMS_TRAVEL: 'Rejse',
  CLAIMS_OTHER: 'Andet',
  '': '',
};

function translate(key: keyof typeof TRANSLATIONS): string {
  return TRANSLATIONS[key];
}

const buildQueueDescription = (navigation: NavigationState): string => {
  if (!navigation.area) {
    throw new Error(`navigation.area is not supposed to be falsy!`);
  }

  if (!navigation.category) {
    throw new Error(`navigation.category is not supposed to be falsy!`);
  }

  const danishCallStartTime = isScheduledBooking(navigation)
    ? format(callStartTime(navigation.bookingDate!, navigation.bookingTime!), DANISH_DATE_TIME_FORMAT)
    : 'Hurtigst muligt';

  let description = `${danishCallStartTime}\r\n${translate(navigation.category)}`;

  switch (navigation.category) {
    case 'insurance':
      description += `\r\n${translate(navigation.selections[navigation.category].category ?? '')}`;
      if (navigation.selections.insurance.category === 'others' && navigation.selections.insurance.comment) {
        description += `\r\n${navigation.selections[navigation.category].comment}`;
      }
      // Based on quick discussion, "Insurane review" could only be seen if the booking can be shceduled
      if (
        isScheduledBooking(navigation) &&
        navigation.selections[navigation.category].reviewInsurance &&
        navigation.selections[navigation.category].category !== 'review'
      ) {
        description += '\r\nJeg ønsker en gennemgang af forsikring';
      }
      break;
    case 'injury':
      if (navigation.area === 'private') {
        description += `\r\n${translate(navigation.selections.injury.category ?? '')}`;
        if (navigation.selections.injury.category === 'CLAIMS_OTHER' && navigation.selections.injury.comment) {
          description += `\r\n${navigation.selections.injury.comment}`;
        }
      }
      break;
    case 'others':
      if (navigation.selections[navigation.category].comment) {
        description += `\r\n${navigation.selections[navigation.category].comment}`;
      }

      // Based on quick discussion, "Insurane review" could only be seen if the booking can be shceduled
      if (isScheduledBooking(navigation) && navigation.selections[navigation.category].reviewInsurance) {
        description += '\r\nJeg ønsker en gennemgang af forsikring';
      }
      break;
  }

  return description;
};

export { buildQueueDescription };
